import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, Button, Card, CardBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("");
  const [selectedOption, setSelectedOption] = useState("Vulnerability Management");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setUsername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setUsername(obj.username);
      }
    }
  }, [props.success]);

  // Handle option selection
  const handleOptionSelect = (option) => {
    if (option === "Compliance and Data Regulation") {
      // Open modal instead of redirect
      setIsModalOpen(true);

      // Uncomment the line below if you want to redirect to an external website instead of showing the modal
      // window.location.href = "https://compliance.compliance.cx";  // Use the full URL to the external domain
    }
  };

  const headerTextStyle = {
    fontSize: "1rem"
  };

  const options = [
    "Vulnerability Management",
    "Compliance and Data Regulation"
  ];

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="d-none d-xl-inline-block ms-2 me-1" style={headerTextStyle}>
            {selectedOption}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {options.map((option) => {
            if (option !== selectedOption) {
              return (
                <React.Fragment key={option}>
                  <DropdownItem onClick={() => handleOptionSelect(option)}>
                    <i className="bx bx-tick font-size-16 align-middle me-1" />
                    {props.t(option)}
                  </DropdownItem>
                </React.Fragment>
              );
            }
            return null;
          })}
        </DropdownMenu>
      </Dropdown>

      {/* Modal to notify the user about administrator access */}
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        centered // This ensures the modal is centered in the viewport
        size="lg" // Optional: You can adjust the size as per your requirement
        backdrop="static" // Optional: Disables closing the modal by clicking outside
      >
        <ModalHeader toggle={() => setIsModalOpen(false)} className="bg-primary text-white">
          {props.t("Administrator Access Required")}
        </ModalHeader>
        <ModalBody>
          <Card className="shadow-sm">
            <CardBody>
              <div style={{ textAlign: "center" }}>
                <i className="bx bx-lock-alt" style={{ fontSize: "2rem", color: "#ff6f61" }} />
                <p >
                  {props.t("You need administrator access to view the Compliance and Data Regulation section.")}
                </p>
              </div>
            </CardBody> 
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>
            {props.t("Close")}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  onSelectOption: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
